import { appConfigApi, createClient, domainApi, egoApi, platformApi, robotApi, simApi, walletApi } from '@robotensor/api'

/** One client per tab: the access token lives here, in memory only. */
export const client = createClient()
export const api = platformApi(client)
export const domains = domainApi(client)
export const sim = simApi(client)
/** MobileEgo: recordings, episodes and labels (realdata) and the taxonomy calls labelling needs (platform). */
export const ego = egoApi(client)
/** Robot control, redesign: calls to the phone, device flags, the linked standby and single runs. */
export const robot = robotApi(client)
/** The redesign's Wallet endpoints: weekly statements, partial withdrawals, withdrawn and earned totals. */
export const wallet = walletApi(client)
/** The app config's staff side (ops): notices and minimum app versions. */
export const appCfg = appConfigApi(client)
